// Function to convert Base64 to Blob
export const base64ToBlob = ({ base64String, contentType = '' }) => {
  const byteCharacters = atob(base64String)
  const byteArrays = []

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i))
  }

  const byteArray = new Uint8Array(byteArrays)
  return new Blob([byteArray], { type: contentType })
}

export const downloadFileBlob = ({ file, fileName }) => {
  const link = document.createElement('a')
  link.href = URL.createObjectURL(file)
  link.download = fileName
  link.click()
}

export const toSnakeCaseString = (str: string) => {
  if (!str) return str
  if (str.toUpperCase() === str) {
    return str.toLowerCase()
  }
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase()
}

// Function to decode HTML entities
export const decodeHtmlEntities = (text: string) => {
  if (!text) return text

  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(text, 'text/html')
    return doc.body.textContent || doc.body.innerText || ''
  } catch (error) {
    console.warn('Failed to decode HTML entities:', error)
    return text
  }
}
